import './App.css';
import '../../fonts/fontello/css/fontello.css'
import Sidebar from "../sidebar/sidebar.container";
import Content from '../content/content';
function App() {
  return (
    <div className="App">
      <Sidebar />
      <Content />
    </div>
  );
}

export default App;
